import {VisibleDays} from '../../../../../features/report/types';
import React from 'react';
import { useAppSelector } from '../../../../../hooks/hooks';
import Box from '@mui/material/Box';
import {FilterState } from './types';
import PropertyFilterPopup from '../property-filter-popup';
import {REmployees} from '../../../../../features/roles/types';
import {PIdNameModel} from '../../../../../features/projects/types';
import {TiminatorAbsenceType, TiminatorType} from '../../../../../features/types/types';

interface Props {
    onChange: (state: FilterState) => Promise<void>;
    disableStatusFilter?: boolean;
    disableEmployeesFilter?: boolean;
    disableAbsenceAndShiftTypesFilter?: boolean;
    disableProjectsFilter?: boolean;
    onSelectedFiltersCountChange?: (count: number) => void;
    showAbsencesToggle?: boolean;
    hasSelected: boolean;
    disabled?: boolean;
    compactNarrowDesktop?: boolean;
    detailedByDay?: boolean;
    onDetailedByDayChange?: (value: boolean) => void;
    visibleDays?: VisibleDays;
    onVisibleDaysChange?: (value: VisibleDays) => void;
    employees?: REmployees[];
    projects?: PIdNameModel[];
    projectTypes?: TiminatorType[];
    shiftTypes?: TiminatorType[];
    absenceTypes?: TiminatorAbsenceType[];
}

const Filter = (props: Props) => {
    const employees = useAppSelector((selector) => selector.rEmployees);
    const projects = useAppSelector((selector) => selector.eProjects);
    const projectTypes = useAppSelector((selector) => selector.types.projects);
    const shiftTypes = useAppSelector((selector) => selector.types.shifts);
    const absenceTypes = useAppSelector((selector) => selector.types.absences);

    const filterEmployees = props.employees ?? employees;
    const filterProjects = props.projects ?? projects;
    const filterProjectTypes = props.projectTypes ?? projectTypes.items;
    const filterShiftTypes = props.shiftTypes ?? shiftTypes.items;
    const filterAbsenceTypes = props.absenceTypes ?? absenceTypes.items;

    return (<Box display={'flex'} gap={2} flexGrow={1} height={'100%'} minWidth={0}>
        <PropertyFilterPopup employees={filterEmployees}
            projects={filterProjects}
            projectTypes={filterProjectTypes}
            shiftTypes={props.disableAbsenceAndShiftTypesFilter === true ? [] : filterShiftTypes}
            absenceTypes={props.disableAbsenceAndShiftTypesFilter === true ? [] : filterAbsenceTypes}
            hasSelected={props.hasSelected}
            onChange={props.onChange}
            disableStatusFilter={props.disableStatusFilter}
            disableEmployeesFilter={props.disableEmployeesFilter}
            disableAbsenceAndShiftTypesFilter={props.disableAbsenceAndShiftTypesFilter} 
            disableProjectsFilter={props.disableProjectsFilter}
            onSelectedFiltersCountChange={props.onSelectedFiltersCountChange}
            showAbsencesToggle={props.showAbsencesToggle}
            disabled={props.disabled}
            compactNarrowDesktop={props.compactNarrowDesktop}
            detailedByDay={props.detailedByDay}
            onDetailedByDayChange={props.onDetailedByDayChange}
            visibleDays={props.visibleDays}
            onVisibleDaysChange={props.onVisibleDaysChange}/>
    </Box>)
};

export default React.memo(Filter);
